// LICENSE_CODE ZON
'use strict';/*jslint ts:true, react: true*/
import React, {useEffect, useState} from 'react';
import {Link} from 'react-router-dom';
import cn from 'classnames';
// @ts-ignore
import cookie from 'cookie';
import date from '/util/date.js';
import {perr} from 'hola_pub_util';
import hopt from 'hola_opt';
import {Button} from '../lib/button';
import {use_theme} from '../settings_ctx';
import styles from './allow_cookies.module.less';

export const Allow_cookies = ()=>{
    const {theme} = use_theme({def: 'hola2023'});
    const [show, set_show] = useState(false);
    const agree = ()=>{
        const ts = Date.now();
        cookie.set('allow_cookies', ts, {domain: `.${window.location.host}`,
            path: '/', expires: date.add(date(), {year: 10})});
        set_show(false);
        perr({id: 'www_cookies_agree', info: {ts}});
    };
    useEffect(()=>{
        if (!hopt.www_hola.show_cookies_alert || cookie.get('allow_cookies'))
            return;
        setTimeout(()=>set_show(true), 500);
    }, []);
    const cls = cn(styles.allow_cookies, theme.root);
    return show && <div className={cls}>
      <div className={styles.content}>
        <div className={styles.text}>
          <p className={cn(theme.p4, theme.med)}>We use cookies</p>
          <Link to="/legal/privacy">Learn more</Link>
        </div>
        <Button on_click={agree} caption="OK" cls={styles.btn}
          theme="hola2023"/>
      </div>
    </div>;
};
